import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "@/lib/api";
import { useKid } from "@/context/KidContext";

export default function Journeys() {
  const { active } = useKid();
  const [journeys, setJourneys] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const params = active ? { child_id: active.id } : {};
    api.get("/journeys", { params }).then(({ data }) => {
      setJourneys(data.journeys || []);
      setLoading(false);
    }).catch(() => setLoading(false));
  }, [active]);

  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-10 py-8" data-testid="journeys-page">
      <div className="flex items-center gap-3">
        <span className="text-3xl">🧭</span>
        <div>
          <h1 className="text-3xl font-extrabold text-[#243B53]">Jornadas</h1>
          <p className="text-[#243B53]/70 text-sm">Trilhas guiadas para você e sua família.</p>
        </div>
      </div>

      {loading ? (
        <div className="mt-8 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
          {[1,2,3].map(i => <div key={i} className="card-soft h-56 animate-pulse bg-[#FFF9ED]" />)}
        </div>
      ) : journeys.length === 0 ? (
        <div className="mt-10 card-soft p-10 text-center text-[#243B53]/60" data-testid="journeys-empty">
          Nenhuma jornada disponível ainda.
        </div>
      ) : (
        <div className="mt-8 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {journeys.map((j) => (
            <Link key={j.key} to={`/journeys/${j.key}`} data-testid={`journey-card-${j.key}`}
                  className="card-soft overflow-hidden hover:-translate-y-1 transition block">
              <div className="aspect-[16/9] bg-[#FFF9ED]">
                {j.cover_image ? <img src={j.cover_image} alt={j.title} className="w-full h-full object-cover"/> : <div className="w-full h-full flex items-center justify-center text-5xl">🧭</div>}
              </div>
              <div className="p-4">
                <div className="flex items-center gap-2 flex-wrap">
                  {j.featured && <span className="chip chip-sun">Destaque</span>}
                  {j.premium && <span className="chip chip-gold">Premium</span>}
                  <span className="chip">{j.duration_days} dias</span>
                </div>
                <h3 className="mt-2 font-extrabold text-[#243B53] text-lg">{j.title}</h3>
                <p className="text-sm text-[#243B53]/70 mt-1 line-clamp-2">{j.description}</p>
                {j.progress?.started && (
                  <div className="mt-3">
                    <div className="text-xs font-bold text-[#243B53]/60">{j.progress.completed_count}/{j.progress.total} etapas</div>
                    <div className="mt-1 progress-track"><div className="progress-fill" style={{ width: `${(j.progress.completed_count/Math.max(1,j.progress.total))*100}%` }}/></div>
                  </div>
                )}
              </div>
            </Link>
          ))}
        </div>
      )}
    </div>
  );
}
